import script from "./CreateChannelForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateChannelForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateChannelForm.vue?vue&type=style&index=0&id=5c5e7074&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5e7074"]])

export default __exports__